module.exports = __webpack_public_path__ + "static/media/YF79_1.4142a77a.jpg";